app.controller('countyPortalsController', async function ($rootScope, $scope, $sce, $http, $location, $window, clientService, systemService, searchService, propertyService, safeApply, $filter) {

  let uploadToGCS = null
  var table       = null

  const host        = "https://api.propertytax.io"
  const currentDate = new Date()
  const CurrentYear = currentDate.getFullYear()
  
  $scope.tableLoading         = true
  $scope.currentCounty        = null
  $scope.currentCountyRecords = null
  $scope.loadFileResults      = ''
  $scope.sessionActivity      = []
  $scope.loadedRecords        = 0

  let countyList    = await systemService.functionCall({ type: "countyList", active_only: true })
  $scope.countyList = countyList.data.data
  safeApply($scope)

  $scope.setCountyRecords = async function (county) {
    $scope.tableLoading = true
    if ($.fn.dataTable.isDataTable('#reportTable')) { 
      $('#reportTable').DataTable().destroy()
      $('#reportTable').empty()
      table = null
    }
    $scope.currentCountyRecords = county
    $scope.countyRecords        = []
    $scope.countyRecords        = await systemService.functionCall({ type: "loadCountyRecords", cad_code: $scope.currentCountyRecords.cad_code })
    createRecordsTable($scope.countyRecords.data.data)
  }
  
  function createRecordsTable(records) {
    if (records == undefined) {
      $scope.tableLoading  = false
      $scope.loadedRecords = 0
      if ($.fn.dataTable.isDataTable('#reportTable')) {
        $('#reportTable').DataTable().destroy()
        $('#reportTable').empty()
        table = null
      } 
      safeApply($scope)
      return
    }
    $scope.loadedRecords  = records.length
    let config            = dataTableConfiguration($scope.currentCountyRecords.cad_code, 1, records)    
    table                 = $('#reportTable').DataTable(config)
    $scope.tableLoading = false
    safeApply($scope)
    table.draw()
  }


  // ------------------------------------------------------------
  // Import County Records - CSV
  // ------------------------------------------------------------
  async function loadDataImportLogs() { 
    $scope.loadFileMessage = 'Loading Recent Log File...'
    let loadDataImportLogsResults = await systemService.functionCall({ type: 'loadDataImportLogs' })
    console.log('loadDataImportLogsResults :>> ', loadDataImportLogsResults);
    if (loadDataImportLogsResults.data.success) {
      $scope.sessionActivity = loadDataImportLogsResults.data.data
    }
    $scope.loadFileMessage = ''
    safeApply($scope)
  }
  loadDataImportLogs()

  $scope.setCounty = function (county) { 
    $scope.currentCounty = county
    if (!uploadToGCS) {
      initUppy($scope.currentCounty.cad_code)
    } else {
      uploadToGCS.close()
      initUppy($scope.currentCounty.cad_code)
    }
  }

  async function initUppy(cadCode) {
    let cad_code         = cadCode
    let type             = 'documents'
    let inline           = true
    let acceptFiles      = ['text/plain', 'text/csv', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
    let maxNumberOfFiles = 1
    let target           = '.UppyDragDrop'
    let prepend_to_file  = "cad_"
    let append_to_file   = "_".concat(moment().format('MM-DD-YYYY_HH-mm'))
    
    let file_type
    let bucket        = "propertytax"
    let path          = 'county_portals/documents'
    let downloadURL   = ''
    let orig_filename = {}
    
    uploadToGCS = new Uppy.Core({
      autoProceed               : true,
      allowMultipleUploadBatches: false,
      restrictions              : {
        allowedFileTypes: acceptFiles,
        maxNumberOfFiles: maxNumberOfFiles
      },
      onBeforeFileAdded: (currentFile, files) => { 
        console.log('currentFile :>> ', currentFile);
        file_type   = currentFile.extension
        downloadURL = `https://storage.googleapis.com/propertytax/county_portals/documents/${prepend_to_file}${cad_code}${append_to_file}.${file_type}`
        
        // Determine Cad_code from file

        // For Excel ->  Can read data and pass to backend ??
        // var reader = new FileReader()        
        // reader.onload = async function (e) {
        //   var arrayBuffer = reader.result          
        //   var bytes = new Uint8Array(e.target.result);
        //   // console.log('bytes :>> ', bytes);          
        //   let cad_info = await systemService.functionCall(
        //     {
        //       type      : "detectCadCode",
        //       sourceType: file_type,
        //       source: arrayBuffer
        //     }
        //     )
        //     console.log('cad_info :>> ', cad_info);
        // }        
        // reader.readAsArrayBuffer(currentFile.data)

        // For CSV -> Works
        // var reader = new FileReader();
        // reader.readAsText(currentFile.data);
        // reader.onload = async function () {
        //   var arrayBuffer = reader.result
        //   // var bytes       = new Uint8Array(arrayBuffer);
        //   // console.log('bytes :>> ', arrayBuffer);
        //   let cad_info = await systemService.functionCall({ type: "detectCadCode", sourceType: file_type, source: arrayBuffer })
        //   console.log('cad_info :>> ', cad_info);
        // }
      }
    }).use(Uppy.Dashboard, {      
      inline                     : false,
      target                     : target || "body",
      fileManagerSelectionType   : 'files',
      proudlyDisplayPoweredByUppy: false,
      showProgressDetails        : true,
      hidePauseResumeButton      : true,
      closeAfterFinish           : (inline===true?false:true)
    }).use(Uppy.XHRUpload, {
      endpoint : host.concat('/gcs/upload/uploadToGCS'),
      method   : 'post',
      fieldName: 'files',
      formData : true,
      bundle   : false
    }).on('file-added', (file) => {   // use this to pass parameters to req.body as req.body.params
      let p = `{ "bucket": "${bucket}", "path": "${path}", "prepend": "${prepend_to_file}", "append": "${append_to_file}" }`
      try {
        file.meta.name = cad_code + "." + file_type
      } catch (error) {
        console.log('error :>> ', error)
        return false
      }
      uploadToGCS.setFileMeta(file.id, { 'params': p })    
    }).on('upload-success', (file, response) => {
      if ($scope.initializing === false) $scope.wiz_obj_dirty = true
      switch (type) {
        case 'documents':
          if (response.body.success) {
            $scope.documentAddTemplate = {
              type        : file.type,
              cad_code    : cad_code,
              name        : file.name,
              doc_date    : "",
              value       : 0,
              upload_date : "",
              filesize    : file.size,
              url_view    : downloadURL,
              url_download: response.body.metadata.download_url,
              gcs         : { bucket: bucket, path: path, filename: `${prepend_to_file}${file.name}${append_to_file}.${file.type}` }
            }
            safeApply($scope)
          } else {
            console.log("Error uploading file! - documents");
          }
          break
      }
      safeApply($scope)
    }).on('dashboard:modal-closed', () => {
      // If no file_type, then no file was selected
      if (file_type) {
        processPortalFile($scope.documentAddTemplate.url_view, $scope.documentAddTemplate.cad_code, file_type )
      }
    })
    uploadToGCS.getPlugin('Dashboard').openModal()
    window.uploadToGCS = uploadToGCS
  }

  $scope.bypassProcess = async function () {
    // let XLScontent = await systemService.functionCall({ type: "loadRemoteCSV", url: 'https://storage.googleapis.com/propertytax/county_portals/documents/cad_043_07-12-2022_16-42.csv', cad_code: '043' })
    // let XLScontent = await systemService.functionCall({ type: "loadRemoteCSV", url: 'https://storage.googleapis.com/propertytax/county_portals/documents/cad_061_07-11-2022_16-36.csv', cad_code: '061' })
    // let XLScontent = await systemService.functionCall({ type: "loadRemoteXLS", url: 'https://storage.googleapis.com/propertytax/county_portals/documents/cad_220_07-12-2022_12-08.xlsx', cad_code: '220' })
    // let XLScontent = await systemService.functionCall({ type: "loadRemoteXLS", url: 'https://storage.googleapis.com/propertytax/county_portals/documents/cad_057_07-08-2022_14-39.xls', cad_code: '057' })
    // console.log('XLScontent :>> ', XLScontent)    
  }

  async function processPortalFile(url, cad_code, file_type) {
    console.log('url, cad_code :>> ', url, cad_code);
    let functionCallName = ''
    switch (file_type) {
      case 'csv':
      case 'txt':
        functionCallName = 'loadRemoteCSV'
        break
      case 'xls':
      case 'xlsx':
        functionCallName = 'loadRemoteXLS'
        break
    }
    $scope.loadFileMessage = 'Loading File...'
    let loadFileResults = await systemService.functionCall({ type: functionCallName, url: url, cad_code: cad_code })

    if (loadFileResults.data.success) { 
      $scope.loadFileResults = `Successfully loaded ${loadFileResults.data.data[0].records} records`
      $scope.sessionActivity = loadFileResults.data.data
    } else {
      $scope.loadFileResults = `Error loading file!`
    }
    $scope.loadFileMessage = ''

    console.log('loadFileResults :>> ', loadFileResults)

    $scope.currentCounty = null
    uploadToGCS.close()
    // uploadToGCS = null
    safeApply($scope)
  }
  // ------------------------------------------------------------

  // DataTables - Configurations
  function dataTableConfiguration(cad_code, table_id, records) {
    let config = {
      data        : records,
      scrollY     : 'calc(100vh -  755px)',
      scrollX     : true,
      pagingType  : 'full_numbers',
      dom         : 'BQfrtip',
      fixedColumns: true,
      keys        : true,
      pageLength  : 25,
      lengthMenu  : [
        [10, 25, 50, 100, -1],
        ['10 rows', '25 rows', '50 rows', '100 rows', 'Show all']
      ],
      buttons: [
        'pageLength', 'spacer', 'colvis', 'spacer', 'copy', 'print', 'csv', 'excel',
        { extend     : 'pdf',
          text       : 'PDF',
          orientation: 'landscape'
        },
        'spacer',
        { extend: 'searchPanes',
          config: { cascadePanes: false }
        },
        'searchPanesClear', 'spacer',
        { extend: 'searchBuilder',
          config: { depthLimit: 3 }
        }
      ],
      columns   : getCountySchemas(cad_code, 'columns'),
      columnDefs: getCountySchemas(cad_code, 'columnDefs')
    }    
    return config
  }

  function getCountySchemas(cad_code, schema) {
    let columns, columnDefs
    switch (cad_code) {
      case '101':        
        columns = [
          { title: "ID",                          data: 'id',                      className: 'dt-body-center dt-head-center' },        
          { title: "Prop ID",                     data: 'prop_id',                 className: 'dt-body-right dt-head-right' },
          { title: "User ID",                     data: 'user_id',                 className: 'dt-body-right dt-head-right' },
          { title: "Appeal ID",                   data: 'appeal_id',               className: 'dt-body-right dt-head-right' },
          { title: "Email",                       data: 'email',                   className: 'dt-body-left dt-head-left' },
          { title: "Account #",                   data: 'hcad_acct',               className: 'dt-body-right dt-head-right' },
          { title: "Agent ID",                    data: 'fid_agent',               className: 'dt-body-center dt-head-center' },
          { title: "Agent Name",                  data: 'fid_agent_name',          className: 'dt-body-left dt-head-left' },
          { title: "Owner Name",                  data: 'owner_name',              className: 'dt-body-left dt-head-left' },
          { title: "Street #",                    data: 'site_street_no',          className: 'dt-body-right dt-head-right' },
          { title: "Street Name",                 data: 'site_street_name',        className: 'dt-body-left dt-head-left' },
          { title: "State Class",                 data: 'state_class',             className: 'dt-body-center dt-head-center' },
          { title: "Prior Appraised Value",       data: 'prior_appraised_value',   className: 'dt-body-right dt-head-right' },
          { title: "Prior Market Value",          data: 'prior_year_market_value', className: 'dt-body-right dt-head-right' },
          { title: "Current Land Value",          data: 'current_land_value',      className: 'dt-body-right dt-head-right' },
          { title: "Current Improvement Value",   data: 'current_imp_value',       className: 'dt-body-right dt-head-right' },
          { title: "Current AG Value",            data: 'current_ag_value',        className: 'dt-body-right dt-head-right' },
          { title: "Current Appraised Value",     data: 'current_appraised_value', className: 'dt-body-right dt-head-right' },
          { title: "Current Market Value",        data: 'current_market_value',    className: 'dt-body-right dt-head-right' },
          { title: "Notice Date",                 data: 'notice_date',             className: 'dt-body-center dt-head-center' },
          { title: "ARB Date",                    data: 'arb_date',                className: 'dt-body-center dt-head-center' },
          { title: "Status",                      data: 'status',                  className: 'dt-body-center dt-head-center' },
          { title: "Protest Agent",               data: 'protest_agent',           className: 'dt-body-center dt-head-center' },
          { title: "Protest Date",                data: 'protest_date',            className: 'dt-body-left dt-head-left' },
          { title: "Hearing Date Formal",         data: 'hearing_date_fml',        className: 'dt-body-left dt-head-left' },
          { title: "Formal Docket",               data: 'formal_docket',           className: 'dt-body-right dt-head-right' },
          { title: "Conclusion Code",             data: 'conclusion_cd',           className: 'dt-body-center dt-head-center' },
          { title: "HRG Status",                  data: 'hrg_status',              className: 'dt-body-center dt-head-center' }        
        ]
        columnDefs = [
          {
            render: function (data, type, row) {
              return $filter('currency')(data, "$", 0)
            }, targets: findTargets(columns, ['prior_appraised_value','prior_year_market_value','current_land_value','current_imp_value','current_ag_value','current_appraised_value','current_market_value'])
          },
          {
            render: function (data, type, row) {
              return data ? moment(data).format('MM-DD-YYYY') : ''
            }, targets: findTargets(columns, ['notice_date','arb_date','protest_date'])
          },
          {
            render: function (data, type, row) {
              return data ? moment(data).format('MM-DD-YYYY h:mm A') : ''
            }, targets: findTargets(columns, ['hearing_date_fml'])
          }
        ]        
        break
      case '220':
        columns = [
          { title: "ID",                          data: 'id',                           className: 'dt-body-center dt-head-center' },
          { title: "Prop ID",                     data: 'prop_id',                      className: 'dt-body-right dt-head-right' },
          { title: "User ID",                     data: 'user_id',                      className: 'dt-body-right dt-head-right' },
          { title: "Appeal ID",                   data: 'appeal_id',                    className: 'dt-body-right dt-head-right' },
          { title: "Email",                       data: 'email',                        className: 'dt-body-left dt-head-left' },
          { title: "Account #",                   data: 'account_number',               className: 'dt-body-right dt-head-right' },
          { title: "Agent Name",                  data: 'agent_name',                   className: 'dt-body-left dt-head-left' },
          { title: "Agent ID",                    data: 'agent_number',                 className: 'dt-body-center dt-head-center' },
          { title: "Class Code",                  data: 'class_code',                   className: 'dt-body-center dt-head-center' },
          { title: "Deed Date",                   data: 'deed_date',                    className: 'dt-body-right dt-head-right' },
          { title: "Deeded Owner",                data: 'deeded_owner',                 className: 'dt-body-left dt-head-left' },
          { title: "Legal Description",           data: 'legal_description',            className: 'dt-body-left dt-head-left' },
          { title: "Neighborhood",                data: 'neighborhood',                 className: 'dt-body-left dt-head-left' },        
          { title: "Primary Building Type",       data: 'primary_building_type',        className: 'dt-body-left dt-head-left' },
          { title: "Address",                     data: 'property_address',             className: 'dt-body-left dt-head-left' },        
          { title: "City",                        data: 'property_city',                className: 'dt-body-left dt-head-left' },
          { title: "Deadline Date",               data: 'protest_deadline_date',        className: 'dt-body-right dt-head-right' },
          { title: "Scheduled Hearing Date",      data: 'scheduled_hearing_date',       className: 'dt-body-right dt-head-right'},
          { title: "Site Class Description",      data: 'site_class_description',       className: 'dt-body-left dt-head-left' },
          { title: "Year Built",                  data: 'year_built',                   className: 'dt-body-center dt-head-center' },
          { title: "Notice Date",                 data: 'notice_date',                  className: 'dt-body-right dt-head-right' },
          { title: "Notice Value",                data: 'notice_value',                 className: 'dt-body-right dt-head-right' },
          { title: "Improvement Appraised Value", data: 'improvement_appraised_value',  className: 'dt-body-right dt-head-right' },
          { title: "Improvement Market Value",    data: 'improvement_market_value',     className: 'dt-body-right dt-head-right' },
          { title: "Land Appraised Value",        data: 'land_appraised_value',         className: 'dt-body-right dt-head-right' },        
          { title: "Land Market Value",           data: 'land_market_value',            className: 'dt-body-right dt-head-right' },
          { title: "Total Appraised Value",       data: 'total_appraised_value',        className: 'dt-body-right dt-head-right' },
          { title: "Total Market Value",          data: 'total_market_value',           className: 'dt-body-right dt-head-right' }
        ]
        columnDefs = [
          { render: function (data, type, row) {
              return $filter('currency')(data, "$", 0)
            }, targets: findTargets(columns, ['notice_value','improvement_appraised_value','improvement_market_value','land_appraised_value','land_market_value','total_appraised_value','total_market_value']),
          },
          { render: function (data, type, row) {
              return data ? moment(data).format('MM-DD-YYYY') : ''
            }, targets: findTargets(columns, ['deed_date','protest_deadline_date','notice_date']),
          },
          {
            render: function (data, type, row) {
              return data ? moment(data).format('MM-DD-YYYY h:mm A') : ''
            }, targets: findTargets(columns, ['scheduled_hearing_date']),
          }
        ]
        break
      case '061':
        columns = [
          { title: "ID",                data: 'id',                 className: 'dt-body-center dt-head-center' },
          { title: "Prop ID",           data: 'prop_id',            className: 'dt-body-right dt-head-right' },
          { title: "User ID",           data: 'user_id',            className: 'dt-body-right dt-head-right' },
          { title: "Appeal ID",         data: 'appeal_id',          className: 'dt-body-right dt-head-right' },
          { title: "Email",             data: 'email',              className: 'dt-body-left dt-head-left' },
          { title: "Account #",         data: 'property_id',        className: 'dt-body-right dt-head-right' },
          { title: "Address",           data: 'property_address',   className: 'dt-body-left dt-head-left' },
          { title: "Agent ID",          data: 'property_agent_id',  className: 'dt-body-center dt-head-center' },
          { title: "state Code",        data: 'state_code',         className: 'dt-body-center dt-head-center' },
          { title: "Protest ID",        data: 'protest_id',         className: 'dt-body-right dt-head-right' },
          { title: "Protest Status",    data: 'protest_status',     className: 'dt-body-left dt-head-left' },
          { title: "Hearing Date",      data: 'hearing_date',       className: 'dt-body-right dt-head-right' },
          { title: "Hearing Location",  data: 'hearing_location',   className: 'dt-body-left dt-head-left' },
          { title: "Beginning Value",   data: 'beginning_value',    className: 'dt-body-right dt-head-right' },
          { title: "Opinion of Value",  data: 'opinion_of_value',   className: 'dt-body-right dt-head-right' },
          { title: "Final Value",       data: 'final_value',        className: 'dt-body-right dt-head-right' },
          { title: "Offer Amount",      data: 'offer_amount',       className: 'dt-body-right dt-head-right' }
        ]
        columnDefs = [
          { render: function (data, type, row) {
              return $filter('currency')(data, "$", 0)
            }, targets: findTargets(columns, ['beginning_value','opinion_of_value','final_value','offer_amount'])
          },
          { render: function (data, type, row) {
              return (moment(data, true).isValid())?moment(data).format('MM-DD-YYYY h:mm A'):''
            }, targets: findTargets(columns, ['hearing_date']),
          }
        ] 
        break
      case '057':
        columns = [
          { title: "ID",                    data: 'id',                   className: 'dt-body-center dt-head-center' },
          { title: "Prop ID",               data: 'prop_id',              className: 'dt-body-right dt-head-right' },
          { title: "User ID",               data: 'user_id',              className: 'dt-body-right dt-head-right' },
          { title: "Appeal ID",             data: 'appeal_id',            className: 'dt-body-right dt-head-right' },
          { title: "Email",                 data: 'email',                className: 'dt-body-left dt-head-left' },
          { title: "Account #",             data: 'account_num',          className: 'dt-body-right dt-head-right' },
          { title: "Division",              data: 'division',             className: 'dt-body-center dt-head-center' },
          { title: "Owner Name",            data: 'owner_name',           className: 'dt-body-left dt-head-left' },
          { title: "DBA",                   data: 'dba',                  className: 'dt-body-left dt-head-left' },
          { title: "Address",               data: 'address',              className: 'dt-body-left dt-head-left' },
          { title: "City",                  data: 'city',                 className: 'dt-body-left dt-head-left' },
          { title: "Building Class",        data: 'building_class',       className: 'dt-body-left dt-head-left' },
          { title: "Current Value",         data: 'current_value',        className: 'dt-body-right dt-head-right' },
          { title: "Notified Value",        data: 'notified_value',       className: 'dt-body-right dt-head-right' },
          { title: "Protest Status",        data: 'protest_status',       className: 'dt-body-left dt-head-left' },
          { title: "Other Protest Status",  data: 'other_protest_status', className: 'dt-body-left dt-head-left' },
          { title: "Protest Deadline",      data: 'protest_deadline',     className: 'dt-body-center dt-head-center' },
          { title: "ARB Schedule",          data: 'arb_schedule',         className: 'dt-body-center dt-head-center' },
          { title: "ARB Date",              data: 'arb_schedule_date',    className: 'dt-body-right dt-head-right' },
          { title: "Authorized",            data: 'is_authorized',        className: 'dt-body-center dt-head-center' },
        ]
        columnDefs = [
          {
            render: function (data, type, row) {
              return $filter('currency')(data, "$", 0)
            }, targets: findTargets(columns, ['current_value','notified_value']),
          },
          {
            render: function (data, type, row) {
              return moment(data).format('MM-DD-YYYY')
            }, targets: findTargets(columns, ['protest_deadline']),
          },
          {
            render: function (data, type, row) {
              return moment(data).format('MM-DD-YYYY h:mm A')
            }, targets: findTargets(columns, ['arb_schedule_date']),
          },
          {
            render: function (data, type, row) {
              return data=='1' ? 'Yes' : 'No'
            }, targets: findTargets(columns, ['is_authorized']),
          }
        ]
        break
      case '043':
        columns = [
          { title: "ID",                        data: 'id' ,                      className: 'dt-body-center dt-head-center'},
          { title: "Prop ID",                   data: 'prop_id',                  className: 'dt-body-right dt-head-right' },
          { title: "User ID",                   data: 'user_id',                  className: 'dt-body-right dt-head-right' },
          { title: "Appeal ID",                 data: 'appeal_id',                className: 'dt-body-right dt-head-right' },
          { title: "Email",                     data: 'email',                    className: 'dt-body-left dt-head-left' },
          { title: "Agent ID",                  data: 'agent_id',                 className: 'dt-body-center dt-head-center' },
          { title: "Owner Name",                data: 'owner_name' },
          { title: "Prop ID",                   data: 'prop_id',                  className: 'dt-body-right dt-head-right' },
          { title: "Authorized",                data: 'authorized_to_protest',    className: 'dt-body-center dt-head-center' },
          { title: "Noticed Market Value",      data: 'noticed_market_value',     className: 'dt-body-right dt-head-right' },
          { title: "Current Market Value",      data: 'current_market_value',     className: 'dt-body-right dt-head-right' },
          { title: "Protest Case ID",           data: 'protest_case_id',          className: 'dt-body-right dt-head-right' },
          { title: "Hearing Date",              data: 'hearing_date',             className: 'dt-body-right dt-head-right' },
          { title: "Protest Status",            data: 'protest_status',           className: 'dt-body-right dt-head-right' },
          { title: "Other Protest By",          data: 'other_protest_by',         className: 'dt-body-left dt-head-left' },
          { title: "Other Prot Hearing Date",   data: 'other_prot_hearing_date',  className: 'dt-body-right dt-head-right' },
          { title: "Appraiser",                 data: 'appraiser',                className: 'dt-body-center dt-head-center' },
          { title: "State Cd",                  data: 'state_cd',                 className: 'dt-body-center dt-head-center' },
          { title: "Situs Address",             data: 'situs_address',            className: 'dt-body-left dt-head-left' },
        ]
        columnDefs = [
          { render: function (data, type, row) {
              return $filter('currency')(data, "$", 0)
          }, targets: findTargets(columns, ['noticed_market_value','current_market_value']),
          },
          { render: function (data, type, row) {
              return moment(data).format('MM-DD-YYYY')
          }, targets: findTargets(columns, ['hearing_date']),
          },
          { render: function (data, type, row) {
              if (data.substring(0, 4) == '1899' || data.substring(0, 4) == null || data.substring(0, 4) == '') {
                return ''
              } else {
                return moment(data).format('MM-DD-YYYY')
              }
            },
            targets: findTargets(columns, ['other_prot_hearing_date']),
          },
          { render: function (data, type, row) {
              return data.substring(0,3)
            },
            targets: findTargets(columns, ['state_cd']),
          }
        ] 
        break
    }
    if (schema === 'columns') return columns
    if (schema === 'columnDefs') return columnDefs
  }

  function findTargets(columns, targets) {
    let result = []
    for (let i = 0; i < columns.length; i++) {
      if (targets.includes(columns[i].data)) result.push(i)
    }
    return result
  }

})  
